export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getAvailableOrganizations: function getAvailableOrganizations() {
            return JsonRPCService.send('pc', 'gateway/organization', 'getAllOrganizations', []);
        },
        getProducerCodeForOrganization: function getProducerCodeForOrganization(organization) {
            return JsonRPCService.send('pc', 'gateway/organization', 'getProducerCodeForOrganization', [organization]);
        }

    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/OrganizationService.js
// module id = 1789
// module chunks = 0